import { render, staticRenderFns } from "./VendTable.vue?vue&type=template&id=3287a9cf"
import script from "./VendTable.vue?vue&type=script&lang=js"
export * from "./VendTable.vue?vue&type=script&lang=js"
import style0 from "./VendTable.vue?vue&type=style&index=0&id=3287a9cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports